import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../../store';
import ScheduleCreatePage from './ScheduleCreatePage';
import SEO from '../../../components/SEO';

const ScheduleEditPage = () => {
  const { scheduleId } = useParams();
  const [accounts] = useGlobalState('accounts');
  const [schedules] = useGlobalState('schedules');
  const [license] = useGlobalState('license');
  const [integrations] = useGlobalState('integrations');
  const navigate = useNavigate();

  return (
    <>
      <SEO title="Edit Scheduler" />
      <ScheduleCreatePage
        id={scheduleId}
        accounts={accounts}
        schedules={schedules}
        license={license}
        integrations={integrations}
        navigate={navigate}
      />
    </>
  );
};

export default ScheduleEditPage;
